import {
  FolderDetailSection,
  FolderHeaderSection,
  InsufficientAccessBackground,
  reactiveVariables,
  StyledActivityCardBackground,
  useAccessState
} from 'modules';
import React from 'react';
import { useParams } from 'react-router-dom';



export type FolderActivityProps = {};

/* eslint-disable-next-line @typescript-eslint/no-unused-vars */
export const FolderActivity = (props: FolderActivityProps) => {
  const params = useParams();
  const access = useAccessState('Folder');
  if (!access.view) {
    return (
      <InsufficientAccessBackground.FC />
    );
  }

  reactiveVariables.resetDocumentsFilter({
    folderId: params.folderId ?? null
  });

  return (
    <StyledActivityCardBackground.FC>
      <FolderHeaderSection.FC />
      <FolderDetailSection.FC />
    </StyledActivityCardBackground.FC>
  );
};
